import { type RouterOutputs } from "@/trpc/react";
import React from "react";
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuList, NavigationMenuTrigger } from "../ui/navigation-menu";
import Link from "next/link";
import { cn } from "@/lib/utils";

type navBarData = RouterOutputs['global']['get_navbar']

const DesktopNavigation = React.memo(({
    data,
    isLoading,
    path,
}: {
    data: navBarData;
    isLoading: boolean;
    path: string
}) => {
    return (
        <div className='hidden xl:flex gap-6 items-center'>
            <NavigationMenu>
                <NavigationMenuList className='flex gap-6 items-center shrink-0'>
                    <NavigationMenuItem>
                        <Link
                            href="/"
                            className='hover:text- duration-300 transition relative group/routes w-fit text-white'
                        >
                            Home
                            <span className={cn("absolute -bottom-1 left-0 h-0.5 scale-y-75 rounded w-full bg-white group-hover/routes:scale-x-100 origin-left transition delay-200 duration-300 scale-x-0", path === "/" ? "scale-x-100" : "scale-x-0")} />
                        </Link>
                    </NavigationMenuItem>
                </NavigationMenuList>
            </NavigationMenu>
            {/* upcomings */}
            <NavigationMenu>
                <NavigationMenuList className='flex gap-6 items-center shrink-0'>
                    <NavigationMenuItem>
                        <NavigationMenuTrigger className='bg-transparent hover:bg-transparent font-normal text-base p-0 group/routes'>
                            Upcoming
                            <span className={cn("absolute bottom-0.5 left-0 h-0.5 scale-y-75 rounded w-full bg-white group-hover/routes:scale-x-100 origin-left delay-200 transition duration-300 scale-x-0 group-data-[state=open]:scale-x-100")} />
                        </NavigationMenuTrigger>
                        <NavigationMenuContent className={cn('px-4 py-2 w-full flex flex-row flex-nowrap gap-8 text-nowrap relative')}>
                            <div className='w-full max-w-96 flex-col flex gap-1'>
                                <p className='font-semibold select-none border-b-2 border-dashed border-gray-600 pb-1 mb-2'>Upcoming</p>
                                <NavLink href='/upcoming-trips' label='Upcoming Trips' />
                                <NavLink href='/upcoming-treks' label='Upcoming Treks' />
                            </div>
                        </NavigationMenuContent>
                    </NavigationMenuItem>
                </NavigationMenuList>
            </NavigationMenu>
            <NavigationMenu>
                <NavigationMenuList className='flex gap-6 items-center shrink-0'>
                    <NavigationMenuItem>
                        <NavigationMenuTrigger disabled={isLoading} className='bg-transparent font-normal text-base p-0 group/routes'>
                            {isLoading ? "loading..." : "Categories"}
                            <span className={cn("absolute bottom-0.5 left-0 h-0.5 scale-y-75 rounded w-full bg-white group-hover/routes:scale-x-100 origin-left delay-200 transition duration-300 scale-x-0 group-data-[state=open]:scale-x-100")} />
                        </NavigationMenuTrigger>
                        <NavigationMenuContent className={cn('px-4 py-2 w-full flex flex-row flex-nowrap gap-8 text-nowrap relative min-h-[150px]')}>
                            {isLoading ? (
                                <div className="w-full max-w-96 flex-col flex gap-1">
                                    <p className="font-semibold select-none border-b-2 border-dashed border-gray-600 pb-1 mb-2">Trending Trips</p>
                                    <div className="animate-pulse space-y-2">
                                        <div className="h-4 bg-gray-400 rounded w-3/4"></div>
                                        <div className="h-4 bg-gray-400 rounded w-1/2"></div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {(data?.trip_cat?.length ?? 0) > 0 && (
                                        <div className='w-full max-w-96 flex-col flex gap-1'>
                                            <p className='font-semibold select-none border-b-2 border-dashed border-gray-600 pb-1 mb-2'>Trending Trips</p>
                                            {data?.trip_cat.map((tripcat) => <NavLink key={tripcat.slug} href={`/trending-trips/${tripcat.slug}`} label={tripcat.title} />)}
                                        </div>
                                    )}
                                    {(data?.trek_cat?.length ?? 0) > 0 && (
                                        <div className='w-full max-w-96 flex-col flex gap-1'>
                                            <p className='font-semibold select-none border-b-2 border-dashed border-gray-600 pb-1 mb-2'>Trending Treks</p>
                                            {data?.trek_cat.map((tripcat) => <NavLink key={tripcat.slug} href={`/trek-category/${tripcat.slug}`} label={tripcat.title} />)}
                                        </div>
                                    )}
                                    {(data?.destination_cat?.length ?? 0) > 0 && data?.destination_cat.map((destcat) => (
                                        <div key={destcat.title} className='w-full max-w-96 flex-col flex gap-1'>
                                            <p className='font-semibold select-none border-b-2 border-dashed border-gray-600 pb-1 mb-2'>{destcat.title}</p>
                                            {destcat.destinations.map((dest) => (
                                                <NavLink key={dest.slug} href={`/destination/${dest.slug}`} label={dest.destination} />
                                            ))}
                                        </div>
                                    ))}
                                </>
                            )}
                        </NavigationMenuContent>
                    </NavigationMenuItem>
                </NavigationMenuList>
            </NavigationMenu>
            {/* <NavigationMenu>
                <NavigationMenuList className='flex gap-6 items-center shrink-0'>
                    <NavigationMenuItem>
                        <NavigationMenuTrigger className='bg-transparent font-normal text-base p-0 group/routes'>
                            Others
                            <span className={cn("absolute bottom-0.5 left-0 h-0.5 scale-y-75 rounded w-full bg-white group-hover/routes:scale-x-100 origin-left delay-200 transition duration-300 scale-x-0 group-data-[state=open]:scale-x-100")} />
                        </NavigationMenuTrigger>
                        <NavigationMenuContent className={cn('px-4 py-2 w-full flex flex-row flex-nowrap gap-8 text-nowrap relative')}>
                            <div className='w-full max-w-96 flex-col flex gap-1'>
                                <p className='font-semibold select-none border-b-2 border-dashed border-gray-600 pb-1 mb-2'>Others</p>
                                <NavLink href='/blogs' label='Blogs' />
                                <NavLink href='/about-us' label='About Us' />
                                <NavLink href='/contact-us' label='Contact Us' />
                            </div>
                        </NavigationMenuContent>
                    </NavigationMenuItem>
                </NavigationMenuList>
            </NavigationMenu> */}
        </div>
    )
})

DesktopNavigation.displayName = 'DesktopNavigation';

export { DesktopNavigation };

function NavLink({ href, label }: { href: string, label: string }) {
    return (
        <Link href={href}>{label}</Link>
    )
}
